/**
 * Deep-link URL helpers.
 * Reads/writes ?country=XX, ?panel=XX, ?tab=XX so pages can be bookmarked.
 * Preserves other query params (e.g. ?admin).
 */

/** Get the ISO2 country code from the current URL, if present */
export function getCountryFromURL(): string | null {
  return new URLSearchParams(window.location.search).get('country');
}

/** Get the panel param (?panel=news, ?panel=events, etc.) */
export function getPanelFromURL(): string | null {
  return new URLSearchParams(window.location.search).get('panel');
}

/** Get the tab param (?tab=regulations, etc.) */
export function getTabFromURL(): string | null {
  return new URLSearchParams(window.location.search).get('tab');
}

/** Push ?country=XX into the URL without reloading the page */
export function setCountryURL(iso2: string): void {
  const params = new URLSearchParams(window.location.search);
  params.set('country', iso2);
  params.delete('panel');
  history.pushState(null, '', `?${params.toString()}`);
}

/** Push ?panel=XX into the URL without reloading the page */
export function setPanelURL(panel: string): void {
  const params = new URLSearchParams(window.location.search);
  params.set('panel', panel);
  params.delete('country');
  params.delete('tab');
  history.pushState(null, '', `?${params.toString()}`);
}

/** Remove ?country, ?panel, ?tab from the URL without reloading the page */
export function clearCountryURL(): void {
  const params = new URLSearchParams(window.location.search);
  params.delete('country');
  params.delete('panel');
  params.delete('tab');
  const qs = params.toString();
  history.pushState(null, '', qs ? `?${qs}` : window.location.pathname);
}
